import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import AppButton from '../atoms/AppButton';
import { IconWhatsapp } from '../atoms/Icon';
import { cta, navegacao } from '../content/site';
import { trackEvent } from '../utils/analytics';

function SiteNavbar() {
  const [rolou, setRolou] = useState(false);
  const [passouHero, setPassouHero] = useState(false);
  const [aberto, setAberto] = useState(false);

  // A borda e a sombra da barra só existem depois que a página sai do topo:
  // sobre o herói elas desenhariam um traço que não separa nada.
  useEffect(() => {
    const aoRolar = () => setRolou(window.scrollY > 8);
    aoRolar();
    window.addEventListener('scroll', aoRolar, { passive: true });
    return () => window.removeEventListener('scroll', aoRolar);
  }, []);

  // O botão de WhatsApp do header só aparece depois que o herói sai de baixo
  // dela: o herói já tem o mesmo botão, bem maior. Os dois juntos na mesma
  // tela seriam duas chamadas verdes competindo pela mesma atenção.
  useEffect(() => {
    const heroi = document.getElementById('topo');
    if (!heroi || typeof IntersectionObserver === 'undefined') {
      setPassouHero(true);
      return undefined;
    }

    const observador = new IntersectionObserver(
      ([entrada]) => setPassouHero(!entrada.isIntersecting),
      { rootMargin: '-56px 0px 0px 0px' },
    );
    observador.observe(heroi);
    return () => observador.disconnect();
  }, []);

  return (
    /* `collapseOnSelect`: tocar num item do menu no celular fecha a gaveta —
       sem isto ela fica aberta cobrindo a seção para a qual a pessoa pulou. */
    <Navbar
      expand="lg"
      fixed="top"
      collapseOnSelect
      expanded={aberto}
      onToggle={setAberto}
      /* A gaveta aberta usa o mesmo visual de "rolou": sobre o herói roxo, a
         barra fica transparente com texto branco, mas a gaveta expandida
         herda essa mesma transparência e o conteúdo do herói vaza por
         baixo dela. Tratar "aberta" como "rolada" devolve o fundo sólido e o
         texto escuro de sempre enquanto o menu está aberto, sem precisar de
         um terceiro visual só para este caso. */
      className={`lp-navbar${(rolou || aberto) ? ' is-scrolled' : ''}`}
    >
      <Container className="shell">
        <Navbar.Brand href="#topo" aria-label="MyPedidos, início">
          <img src="/images/icon-horizontal.png" alt="MyPedidos" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="lp-nav" aria-label="Abrir menu" />

        <Navbar.Collapse id="lp-nav">
          <Nav className="ms-auto align-items-lg-center">
            {navegacao.map((item) => (
              <Nav.Link key={item.href} href={item.href}>
                {item.label}
              </Nav.Link>
            ))}
          </Nav>

          {/* Só a ação de WhatsApp: a LP não leva a nenhuma tela de login do
              painel, então não há "Entrar" para oferecer aqui. E ela só
              aparece depois do herói: sobre ele, o mesmo botão já existe bem
              maior, e duas chamadas verdes na mesma tela se anulariam. */}
          <div className={`nav-cta d-flex flex-column flex-lg-row gap-2 mt-3 mt-lg-0 ms-lg-4${passouHero ? ' is-visible' : ''}`}>
            <AppButton
              href={cta.principal.href}
              variant="whatsapp"
              size="sm"
              tabIndex={passouHero ? undefined : -1}
              onClick={() => trackEvent('click_whatsapp', { posicao: 'header' })}
            >
              <IconWhatsapp size={16} />
              Falar no WhatsApp
            </AppButton>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default SiteNavbar;
